import React from 'react'
import { useParams } from 'react-router-dom'
import Colors from 'colors.json'

import DatetimePickerInput from 'components/DatetimePickerInput'
import Input from 'components/Input'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { Form, Formik } from 'formik'

import { EVoucherRedemptionTxSchemas } from 'schemas/EVoucherRedemptionTxSchemas'
import { useEVoucherRedemptionTx } from './useEVoucherRedemptionTx'
import { useEVoucherRedemptionVouchers } from './useEVoucherRedemptionVouchers'
import MerchantLookupTx from 'views/MemberProfile/ManualTx/MerchantLookupTx'
import { useMemberTXReasons } from './useMemberTXReasons'
import { DropDownItem } from 'types/components'

const Index: React.FC<{ onCloseModal: () => void }> = ({
  onCloseModal,
}): React.ReactElement => {
  // STATES
  const { traderId } = useParams()
  const memberTraderId = parseInt(String(traderId) || '0')
  const { membersTXReasonsOptions, memberTXReasonsModStatus } =
    useMemberTXReasons()
  const {
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleSubmitEVoucherRedemptionTx,
    handleClearEVoucherRedemptionTx,
  } = useEVoucherRedemptionTx(Number(traderId), onCloseModal)

  const { voucherOptions, isLoadingVouchers } = useEVoucherRedemptionVouchers(memberTraderId)

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={EVoucherRedemptionTxSchemas}
      onSubmit={handleSubmitEVoucherRedemptionTx}
    >
      {({ values, isSubmitting, setFieldValue, errors, touched }) => {
        return (
          <Form className="flex flex-col">
            <div className="mb-4">
              <DatetimePickerInput
                title={'Transaction Date'}
                setFieldName="transactionDate"
                setFieldValue={setFieldValue}
              />
              <MerchantLookupTx
                isMerchantLookupToggle={true}
                setFieldValue={setFieldValue}
              />
              <Dropdown
                title="Select Voucher"
                options={voucherOptions}
                className="w-full tracking-wider mb-4"
                borderColor="#C4C4C4"
                onSelect={(option: DropDownItem | null) => {
                  if (option) {
                    setFieldValue('tenderDetail', [
                      {
                        ...values.tenderDetail[0],
                        tenderIdentifier: option.value,
                      },
                    ]),
                      setFieldValue('tenderIdentifier', option.value)
                  }
                }}
                placeholder="Search vouchers..."
                isSearchable
              />
              <div className="flex  gap-4 items-center">
                <Input
                  name="ident"
                  label="Identifier"
                  disabled
                  containerClassName="w-full"
                />
                <Input
                  name="externalTransactionId"
                  label="External Trans ID"
                  // disabled
                  containerClassName="w-full"
                />
              </div>
              <div className="flex gap-4 items-center">
                <Input
                  name="creditValue"
                  label="Credit Value"
                  disabled
                  containerClassName="w-full"
                />
                <Input
                  name="tenderIdentifier"
                  label="Voucher Code"
                  disabled
                  containerClassName="w-full"
                />
              </div>
              <div className="flex gap-4 items-center">
                <Input
                  name="storeId"
                  label="Store Trader ID"
                  disabled
                  containerClassName="w-full"
                />
              </div>
            </div>

            <footer className="flex justify-end pb-4 pl-4 pr-4">
              <Button
                type="submit"
                className="mr-2 rounded bg-primary"
                disabled={isSubmitting}
              >
                <span className="tracking-wider font-bold">Submit</span>
              </Button>
              <Button
                className="bg-white border rounded border-primary"
                onClick={onCloseModal}
                style={{ color: Colors.primary }}
              >
                <span className="tracking-wider font-bold">Cancel</span>
              </Button>
            </footer>
          </Form>
        )
      }}
    </Formik>
  )
}

export default Index
